/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdUploadProps } from './type';

export const uploadDefaultProps: TdUploadProps = {
  allowUploadDuplicateFile: false,
  autoUpload: true,
  draggable: undefined,
  defaultFiles: [],
  isBatchUpload: false,
  max: 0,
  method: 'POST',
  multiple: false,
  name: 'file',
  showImageFileName: true,
  showThumbnail: false,
  showUploadProgress: true,
  theme: 'file',
  uploadAllFilesInOneRequest: false,
  uploadPastedFiles: true,
  useMockProgress: true,
  withCredentials: false,
};
